module.exports = __webpack_public_path__ + "ea2fe1060dd0adbe6d734fc7795a8df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Characters/bear.png
// module id = 633
// module chunks = 0